import { Actions } from "../table/table.actions"
import createTableReducer, { DEFAULT_STATE } from "../table/table.reducer"

const INITIAL_STATE = {
  ...DEFAULT_STATE,
  sorting: ["to=asc"],
  defaultSorting: [
    "to=asc",
    "from=asc",
    "code.title=asc",
    "starting_balance_hours=asc",
    "requested_hours=asc",
    "remaining_hours=asc",
  ],
}

const planningAvailabilitiesTableReducer = (state = INITIAL_STATE, action: Actions) =>
  createTableReducer("USER_ENTITLEMENTS_TABLE", {})(state, action)

export default planningAvailabilitiesTableReducer
